import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(private http: HttpClient) {}

  login(tipo_documento: string, codigo_documento: string, clave: string, id_rol: number): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/login', { tipo_documento, codigo_documento, clave, id_rol });
  }

  obtenerDocumentos(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + `/documento`);
  }

  loginInstitucion(cod_mod: string, clave: string): Observable<any> {
    return this.http.post<any>(environment.apiUrl + `/login/institucion`, {
      cod_mod,
      clave,
    });
  }
}
